import { useEffect, useMemo, useState } from "react";
import { transformToStringifiedDateAndTime } from "./utils";
export function findCoords(timestamps, values, current) {
    if (timestamps.length > 0) {
        let index = 0;
        let diff = Math.abs(current - timestamps[0]);
        for (let i = timestamps.length; --i;) {
            const n = Math.abs(current - timestamps[i]);
            if (n < diff) {
                diff = n;
                index = i;
            }
        }
        return [timestamps[index], values[index]];
    }
    return [current, 0];
}
export function transformToDefaultValue(key, seriesEntry, current) {
    const [x, y] = findCoords(seriesEntry.timestamps, seriesEntry.values, current);
    return {
        key,
        xValue: x,
        yValue: y,
    };
}
export function transformToDefaultValues(detailedItems, current) {
    const coordsArray = detailedItems.map((item) => transformToDefaultValue(item.key, item.seriesEntry, current));
    return coordsArray.find((coords) => coords.yValue === 1);
}
export function useDynamicLegend(chartDivId, defaultValues, predicate, formatY) {
    const [values, setValues] = useState();
    useEffect(() => {
        const eventType = "series-changed";
        const handler = (ev) => {
            var _a;
            const customEvent = ev;
            setValues((_a = customEvent.detail) === null || _a === void 0 ? void 0 : _a.find(predicate));
        };
        const element = document.getElementById(chartDivId);
        element.addEventListener(eventType, handler);
        return () => element.removeEventListener(eventType, handler);
    }, []);
    const current = values || defaultValues;
    const entry = useMemo(() => current
        ? {
            xValue: transformToStringifiedDateAndTime(current.xValue),
            yValue: formatY(current),
        }
        : undefined, [current]);
    return entry;
}
//# sourceMappingURL=legend.js.map